import { render, staticRenderFns } from "./AreaManagerPlaceholder.vue?vue&type=template&id=5c69b6a4"
import script from "./AreaManagerPlaceholder.vue?vue&type=script&lang=js"
export * from "./AreaManagerPlaceholder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports